import { ExternalArticleStatus } from '@/common/api/params/externalArticle'

import Badge, { BadgeType } from '@/components/view/atoms/badge/Badge'

// 状態ごとのバッジの種類。ラベルの文言はサーバ側（routers/external_article.STATUS_LABELS）が正で、
// ここでは見た目だけを持つ
const STATUS_BADGE: Record<string, BadgeType> = {
  [ExternalArticleStatus.OK]: BadgeType.SQUARE_SUCCESS,
  [ExternalArticleStatus.PENDING]: BadgeType.SQUARE_SECONDARY,
  [ExternalArticleStatus.EXCLUDED]: BadgeType.SQUARE_CAUTION,
  [ExternalArticleStatus.MISSING]: BadgeType.SQUARE_CRITICAL
}

const ExternalArticleStatusBadge = ({ status, label }: { status: string; label: string }) => (
  <Badge size={12} badgeType={STATUS_BADGE[status] ?? BadgeType.SQUARE_SECONDARY}>
    {label}
  </Badge>
)

export default ExternalArticleStatusBadge
